var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"core row-between"},[(!_vm.$route.meta.hideSidebar)?_c('sidebar',{on:{"getHelpDetail":_vm.getHelpDetail}}):_vm._e(),_c('div',{staticClass:"defaultModel bg-white",class:{ model: !_vm.$route.meta.hideSidebar }},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.helpDetail.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }